import React, { useContext, useEffect, useState } from "react";
import { Form, Col, Button, Row } from "react-bootstrap";
import MemberLocationDropdown from "../../../components/form/MemberLocationDropdown";
import FormValidation from "../../../components/form/validation/FormValidation";
import { ProgramSubscriptions } from "shared/constants/ProgramSubscriptions";
import { UserContext } from "shared/context/UserContext";

export function PayerBinSetupForm(props) {
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const userContext = useContext(UserContext);

  useEffect(() => {
    setLoaded(false);
  }, [userContext.locations, userContext.recLocations]);

  useEffect(() => {
    if (!loaded && selectedLocations.length > 0) {
      setLoaded(true);
      submitForm();
    }
  }, [selectedLocations, loaded]);

  function handleFormSubmit(event) {
    event.preventDefault();
    submitForm();
  }

  function submitForm() {
    let validationIssueMessage = FormValidation({
      selectedLocations: selectedLocations,
    });

    if (validationIssueMessage) {
      alert(validationIssueMessage);
    } else {
      props.handleFormSubmit({ mmids: selectedLocations.join(",") });
    }
  }

  return (
    <Form onSubmit={handleFormSubmit}>
      <Row className="justify-content-start">
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>Location (NCPDP)</Form.Label>
          <Form.Control
            as={MemberLocationDropdown}
            onChange={(locations) => setSelectedLocations(locations)}
            programSubscription={ProgramSubscriptions.Rec}
          />
        </Col>
        <Col md="auto" className="d-flex flex-column">
          <Button className="inline-show-result-button" size="sm" type="submit">
            Show Results
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
